import React, { useRef } from 'react';
import { useButton } from 'components/Button2';
import type { ButtonProps } from 'components/Button2/Button2';
import { IconX } from '@frameio/vapor-icons';
import styles from './ChipCloseButton.module.css';

type ChipCloseButtonProps = Pick<
  ButtonProps,
  'onPress' | 'isDisabled' | 'aria-label'
> & {
  color: string;
};

export function ChipCloseButton({
  onPress,
  color,
  isDisabled,
  'aria-label': ariaLabel,
}: ChipCloseButtonProps) {
  const ref = useRef<HTMLDivElement>(null);

  // Cast needed: useButton expects HTMLButtonElement but we use div to avoid nesting buttons
  const { buttonProps } = useButton(
    ref as unknown as React.RefObject<HTMLButtonElement>,
    {
      isDisabled,
      onPress,
      elementType: 'div',
    }
  );

  return (
    <div
      ref={ref}
      aria-label={ariaLabel}
      className={styles.closeButton}
      data-testid="chip-iconafter-button"
      style={{ color }}
      {...buttonProps}
    >
      <IconX aria-hidden={true} size={16} />
    </div>
  );
}
